export default __webpack_public_path__ + "static/media/Acusan-50-eng.302882af.jpg";